import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import AppContextProvider from "./context/AppContext";

import { HelmetProvider } from "react-helmet-async";

import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <HelmetProvider>
    <AppContextProvider>
      <App />
    </AppContextProvider>
  </HelmetProvider>
);